export class SenceiveSubscription {
  public osmosProjectId: number;
  public senceiveProjectId: string;
  public senceiveUser: string;
  public senceivePassword: string;
}
